import React, { FC } from 'react';
import { useUnfinalizeMessageMutation } from '../../message/message.service';
import { toast } from 'react-toastify';
import cls from './OpenDialogButton.module.scss';

type OpenDialogButtonProps = {
  id: string;
};

const OpenDialogButton: FC<OpenDialogButtonProps> = ({ id }) => {
  const [openDialog] = useUnfinalizeMessageMutation();
  const openDialogHandler = async () => {
    await openDialog(id);
    toast.success('Dialog opened');
  };
  return (
    <button className={cls.Button} onClick={openDialogHandler} title="Open">
      Resume
    </button>
  );
};

export default OpenDialogButton;
